import { IntlShape } from 'react-intl';

export const dictionary = {
    season_number: (intl: IntlShape, { seasonNumber }: { seasonNumber: number }) =>
        intl.formatMessage(
            {
                id: 'containers.OverviewContinueSnippet.24fa82b55f5b075fdb90cb41ea3a1282',

                defaultMessage: 'Season {seasonNumber}',
                description: 'Номер сезона',
            },
            {
                seasonNumber,
            }
        ),
    episode_number: (intl: IntlShape, { episodeNumber }: { episodeNumber: number }) =>
        intl.formatMessage(
            {
                id: 'features.movie.728f6fa5b22043dfcae6ad27b35eeeda',
                defaultMessage: 'Episode {episodeNumber}',
                description: 'Название серии',
            },
            {
                episodeNumber,
            }
        ),
    content_actions__watch_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.de3c731be5633838089a07179d301d7b',
            defaultMessage: 'Play',
            description: 'Текст кнопки "Смотреть"',
        }),
    content_actions__play_series_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.c3c0bb7eaeb15077d1af1fc85406ff11',

            defaultMessage: 'Play series',
            description: 'Текст кнопки "Смотреть сериал"',
        }),
    content_actions__play_movie_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.542c3428091670013c6a559f45ece642',
            defaultMessage: 'Play movie',
            description: 'Текст кнопки "Смотреть фильм"',
        }),
    content_actions__keep_watching_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.63e7848b0fc6c046dc9b2146e1be7331',
            defaultMessage: 'Keep watching',
            description: 'Текст кнопки "Продолжить просмотр"',
        }),
    content_actions__trailer_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.7777d162b1fa729345ddb7de48654012',
            defaultMessage: 'Trailer',
            description: 'Текст кнопки трейлера',
        }),
    content_actions__more_actions_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.MoreActionsDropdown.8b921bab23941e9a20727cec7ffa1137',

            defaultMessage: 'Action menu',
            description: 'Лейбл кнопки меню действий',
        }),
    content_actions__try_again_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.movie.i18n.f915a95e609bbd517a8a1e7bdcceef37',
            defaultMessage: 'Try again',
            description: 'Текст кнопки повторной загрузки content actions',
        }),
    content_actions__emotions_dismiss: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.c8a59e7135a20b362f9c768b09454fdb',
            defaultMessage: 'Dismiss',
            description: 'Dismiss button label',
        }),
    content_actions__watched_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.8a10e06466b3311c50c21b05b44206aa',
            defaultMessage: 'Watched',
            description: 'Информация, что контент просмотрен',
        }),
    content_actions__explore_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.1d655216b28b4b3dae106336ceff9ddb',
            defaultMessage: 'Watch similar movies & series',
            description: 'Button text to exit fake title page',
        }),
    planned_to_watch__default_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.e08642d46f86477b5e08d0b692c27e28',
            defaultMessage: 'Watch later',
            description: 'Кнопка добавления в избранное',
        }),
    about_button__series_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.3ece3df61ef201fe22e321fc822d53aa',
            defaultMessage: 'About the TV series',
            description: 'Ссылка на информацию о сериале',
        }),
    about_button__movie_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.f7fc0b8dfcd09bb8bf389eb838186ed0',
            defaultMessage: 'About the movie',
            description: 'Ссылка на информацию о фильме',
        }),
    content_actions__not_interested_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.not-interested-button.c0a38f62cf6f3c0945d2b583f8b79742',
            defaultMessage: 'Not interested',
            description: 'Текст кнопки добавления в неинтересное',
        }),
    content_actions__not_interested_tooltip: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.78f7ef670a14533955dd5bb99208613b',
            defaultMessage: "We'll show fewer similar movies and TV series",
            description: 'Подсказка при наведении на кнопку неинтересно в контентных действиях',
        }),
    movie_not_found__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.51a69c740a6bf18ee0414a38d798b832',
            defaultMessage: 'Movie not found',
            description: 'Подпись ошибки, если фильм не найден',
        }),
    movie_not_found__description: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.7db66a42bb515f3ce685bb5e5119de0c',
            defaultMessage: 'It may have been moved, or the page address might be incorrect',
            description: 'Пояснение к ошибке, если фильм не найден',
        }),
    movie_info__top10: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'common.ott.components.OverviewMeta.a15b2b975becae8c315e9bf80e0ef661',
            defaultMessage: 'Top 10',
            description: 'Название рейтинга',
        }),
    movies_info__top10_screen_reader_position: (
        intl: IntlShape,
        { position }: { position: number }
    ) =>
        intl.formatMessage(
            {
                id: 'common.ott.components.OverviewMeta.0fe4aaab120a9e0a0a7e92965c268fea',
                defaultMessage: `{position, select,
                                0 {zero}
                                1 {first}
                                2 {second}
                                3 {third}
                                4 {fourth}
                                5 {fifth}
                                6 {sixth}
                                7 {seventh}
                                8 {eighth}
                                9 {ninth}
                                10 {tenth}
                                other {unknown}
                            } place`,
                description:
                    "Позиция в топ-10. Озвучка для вспомогательных технологий. Например: 'Первое место', а не 'Один место.'",
            },
            { position }
        ),
    movie_info__top10_text_position: (intl: IntlShape, { position }: { position: number }) =>
        intl.formatMessage(
            {
                id: 'allplay.topListPositionNumeric',
                defaultMessage: '{position} place',
                description: "Позиция в топ-10. Например: '1 место', '2 место'.",
            },
            { position }
        ),
    movie_info__start_year_of_series: (intl: IntlShape, { start }: { start: number }) =>
        intl.formatMessage(
            {
                id: 'features.movie.31827643faf8abe8644dba82c39eafb1',
                defaultMessage: 'from {start}',
                description: 'Начало сериала в его описании',
            },
            {
                start,
            }
        ),
    movie_info__seasons_quantity: (
        intl: IntlShape,
        { seasonsQuantity }: { seasonsQuantity: number }
    ) =>
        intl.formatMessage(
            {
                id: 'features.movie.87515b9f2f40a796e15534274f600f9b',
                defaultMessage:
                    '{seasonsQuantity} {seasonsQuantity, plural, one {season} few {seasons} other {seasons}}',
                description: 'Название для одного или нескольких сезонов в описании',
            },
            { seasonsQuantity }
        ),
    movie_info__audio_aria_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'ui.content-features.voice-features.3095114a9146ee67901827d61ec7a6c2',
            defaultMessage: 'Audio tracks',
            description: 'Лейбл для иконки аудиодорожек',
        }),
    movie_info__subtitles_aria_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'ui.content-features.subtitle-features.6a73085e389c48beca8b3f4629b4b1e4',
            defaultMessage: 'Subtitles',
            description: 'Лэйбл для иконки субтитров',
        }),
    emotions__dislike: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.ea04e7ef514a25e465197a31c71f52f0',
            defaultMessage: 'Dislike',
            description: 'Dislike button label',
        }),
    emotions__average: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.b1897515d548a960afe49ecf66a29021',
            defaultMessage: 'Average',
            description: 'Neutral button label',
        }),
    emotions__like: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.98b82c200a2e309b24cb481970f3fcc4',
            defaultMessage: 'Like',
            description: 'Like button label',
        }),
    emotions__love: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.8bd7a1153a88761ad9d37e2f2394c947',
            defaultMessage: 'Love',
            description: 'Love button label',
        }),
    content_details__actors_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.adfc63cd5235c17623d396d984e71751',
            defaultMessage: 'Starring',
            description: 'Заголовок списка актеров',
        }),
    content_details__directors_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.a81d7a070fbeb59ca04c093008e3e4b0',
            defaultMessage: 'Directors',
            description: 'Заголовок списка режиссёров',
        }),
    content_details__audio_tracks_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.3095114a9146ee67901827d61ec7a6c2',
            defaultMessage: 'Audio tracks',
            description: 'Заголовок списка аудиодорожек',
        }),
    content_details__subtitle_tracks_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.6a73085e389c48beca8b3f4629b4b1e4',
            defaultMessage: 'Subtitles',
            description: 'Заголовок списка субтитров',
        }),
    content_details__action_more: (intl: IntlShape, { count }: { count: number }) =>
        intl.formatMessage(
            {
                id: 'features.movie.8b80b57a48b365380885cfef32122824',
                defaultMessage: '{count} left',
                description: 'Текст кнопки еще с остатком {count}',
            },
            { count }
        ),
    content_details__features_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.571094bb27864b600d8e6b561a137a55',
            defaultMessage: 'Quality',
            description: 'Заголовок блока с качеством',
        }),
    content_details__about_4k: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.d17026a18810aef6feac3987d14c1dc7',
            defaultMessage: '4K is only available on big screens',
            description: 'Текст о том, что 4К доступно только на больших экранах',
        }),
    content_details__install_on_tv_link_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.884e0e94a3d2c36d896b91cc44fd2b26',
            defaultMessage: 'Install on the TV',
            description: 'Текст ссылки на инструкцию по установке на ТВ',
        }),
    content_details__for_adult: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.101299b0fac165aca741253d7453a539',
            defaultMessage: '18+',
            description: 'Текст возрастного ограничения в деталях карточки тайтла',
        }),
    content_details__series_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.3ece3df61ef201fe22e321fc822d53aa',
            defaultMessage: 'About the TV series',
            description: 'Ссылка на информацию о сериале',
        }),
    content_details__movie_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.f7fc0b8dfcd09bb8bf389eb838186ed0',
            defaultMessage: 'About the movie',
            description: 'Ссылка на информацию о фильме',
        }),
    series_navigator__season: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.SeriesNavigator.6c7a445aa85245a31c24d3e8ee5408b9',
            defaultMessage: 'Season',
            description: 'Текст для сезонов в навигаторе серий',
        }),
    series_navigator__episodes: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.SeriesNavigator.1036de8f1b7044f15e5f0b911955fb1d',
            defaultMessage: 'Episodes',
            description: 'Текст для серий в навигаторе серий',
        }),
    movie_tabs__overview: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.tabs.overview',
            defaultMessage: 'Overview',
            description: 'Таб Overview на карточке сериала',
        }),
    movie_tabs__seasons_episodes: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.tabs.seasons-episodes',
            defaultMessage: 'Seasons & Episodes',
            description: 'Таб Seasons & Episodes на карточке сериала',
        }),
    selection_similar: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.selections.similar',
            defaultMessage: 'You Might Also Like',
            description: 'Название подборки похожих фильмов или сериалов',
        }),
    selection_director: (intl: IntlShape, { director }: { director: string }) =>
        intl.formatMessage(
            {
                id: 'features.movie.selections.director',
                defaultMessage: 'Director: {director}',
                description: 'Название подборки фильмов по режиссёру',
            },
            { director }
        ),
    fake_title_tooltip__close_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.ContentOverview.d3d2e617335f08df83599665eef8a418',
            defaultMessage: 'Close',
            description: 'Close button label',
        }),
    fake_title_tooltip__unavailable_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.ContentOverview.c440ca894b75ae3314ab3a6700ccd046',
            defaultMessage:
                'This content is available only in the UAE, Qatar, Oman, Bahrain, Kuwait, Jordan, Iraq and Egypt.',
            description: 'Text for unavailable pages',
        }),
    plural_episodes_count: (intl: IntlShape, { episodesCount }: { episodesCount: number }) =>
        intl.formatMessage(
            {
                id: 'common.ott.utils.9dad991279e95efe1c803db28aab2cac',
                defaultMessage: '{episode, plural, one {Episode} few {Episodes} other {Episodes}}',
                description: 'Множественное число для слова "серия"',
            },
            { episode: episodesCount }
        ),
    series_navigator__all_seasons: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.serial-structure.63ac5b92c36efe17af7d031227fc2d97',
            defaultMessage: 'All seasons',
            description: 'Текст все сезоны в навигаторе серий',
        }),
    movie_card_modal_error__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.navigation.731e024ead4b1b6cdedeb8e74373c451',
            defaultMessage: 'Server error',
            description: 'Подпись ошибки, если произошла ошибка сервера',
        }),
    movie_card_modal_error__description: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.navigation.2a7237cef3c338d781efaa102853ac8b',
            defaultMessage: 'Error in the request',
            description: 'Подпись ошибки, если был некорректный запрос',
        }),
    movie_card_modal_error__refresh: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.RefreshButton.63a6a88c066880c5ac42394a22803ca6',
            defaultMessage: 'Refresh',
            description: 'Текст кнопки обновить в компонентах',
        }),
};
